import { Route, Switch as ReactRouterSwitch } from 'react-router-dom';
import React, { useContext } from 'react';
import routes from '../../routes';
import NotFound from '../components/_error/NotFound';
import useRoutes from '../components/_hook/useRoutes';
import useRouter from '../components/_hook/useRouter';
import Context from '../context';

export default function Switch() {
  const { path } = useRoutes();
  const { user } = useContext(Context);

  const defaultCompanyId = user.companies[0].id;

  return (
    <ReactRouterSwitch>
      <Route
        exact
        path="/:app"
        component={() => {
          const { params, history } = useRouter();
          if (params.app === 'messenger') {
            history.push(
              path(`${params.app}.chatrooms`, {
                companyID: defaultCompanyId,
              })
            );
          } else {
            history.push(
              path(`${params.app}.dashboard`, {
                companyID: defaultCompanyId,
              })
            );
          }

          return <></>;
        }}
      />
      <Route
        exact
        path="/:app/:companyID"
        component={() => {
          const { params, history } = useRouter();
          if (params.app === 'messenger') {
            history.push(
              path(`${params.app}.chatrooms`, {
                companyID: params.companyID || defaultCompanyId,
              })
            );
          } else {
            history.push(
              path(`${params.app}.dashboard`, {
                companyID: params.companyID || defaultCompanyId,
              })
            );
          }
          return <></>;
        }}
      />
      <Route
        exact
        path="/"
        component={() => {
          const { history } = useRouter();
          history.push(
            path('business.dashboard', {
              companyID: defaultCompanyId,
            })
          );
          return <></>;
        }}
      />
      {routes.map((route, index) => (
        <Route
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          exact={route.exact}
          path={route.path}
          component={route.component}
        />
      ))}
      <Route render={() => <NotFound />} />
    </ReactRouterSwitch>
  );
}
